import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { ReviewsRoutingModule } from './reviews-routing.module'
import { ReviewsListComponent } from './pages/reviews-list/reviews-list.component'
import { SharedModule } from 'src/app/shared/shared.module';
import { ReviewsTableComponent } from './components/reviews-table/reviews-table.component';
import { ReviewDetailsComponent } from './components/review-details/review-details.component'

@NgModule({
	declarations: [ReviewsListComponent, ReviewsTableComponent, ReviewDetailsComponent],
	imports: [CommonModule, ReviewsRoutingModule, SharedModule],
})
export class ReviewsModule {}
